// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@media not print {
  .top-nav {
    margin: 1rem 0;
    position: sticky;
    text-align: center;
    top: 0;
    transition: margin .1s ease-out;
    z-index: 1000
  }
}

@media only screen and (min-width: 992px) {
  .top-nav {
    display: none
  }
}

@media not print {
  .top-nav button {
    appearance: none;
    background: #002664;
    border: 3px solid transparent;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    display: inline-block;
    font-family: Open Sans,-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;
    font-size: 16px;
    font-size: 1rem;
    font-weight: 600;
    font-weight: 500;
    line-height: 1.5;
    line-height: 1;
    margin-bottom: -1px;
    padding: .5rem 1rem;
    position: relative;
    text-decoration: none;
    text-shadow: none;
    top: -1px;
    transition: .15s ease;
    transition-property: color,background-color,border;
    vertical-align: middle;
    width: 100%
  }

    .top-nav button:active {
      border-style: solid;
      border-width: 3px
    }

    .top-nav button:active, .top-nav button:focus {
      box-shadow: none;
      text-shadow: none
    }

    .top-nav button:focus {
      border-style: solid;
      border-width: 3px;
      outline: 3px solid #9263de;
      outline-offset: 2px
    }

    .top-nav button:disabled {
      cursor: not-allowed;
      opacity: .3
    }

    .top-nav button[href] {
      color: #fff
    }

    .top-nav button:active, .top-nav button:focus {
      background: #002664
    }

    .top-nav button:hover:not(:disabled) {
      background: #153d73;
      color: #fff
    }

    .top-nav button:before {
      speak: none;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      display: inline-block;
      content: "\\e901";
      font-family: "health-stats-icons" !important;
      font-size: 1em;
      font-style: normal;
      font-variant: normal;
      font-weight: 400;
      line-height: 1;
      margin-right: .5rem;
      position: relative;
      text-transform: none;
      top: 2px;
      top: 0
    }

  .top-nav > ol, .top-nav > ol.menu {
    -webkit-overflow-scrolling: touch;
    border-collapse: collapse;
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    display: block;
    display: none;
    list-style-type: none;
    margin: 0;
    max-height: 98vh;
    max-height: calc(100vh - 38px - 1rem);
    overflow-x: visible;
    overflow-y: auto;
    padding: 10px
  }

  .top-nav > ol, .top-nav > ol.menu {
    background: linear-gradient(#fff 33%,hsla(0,0%,100%,0)),linear-gradient(hsla(0,0%,100%,0),#fff 66%) 0 100%,radial-gradient(farthest-side at 50% 0,rgba(0,0,0,.2),transparent),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,.2),transparent) 0 100%;
    background-attachment: local,local,scroll,scroll;
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: 100% 45px,100% 45px,100% 15px,100% 15px
  }
}

@media screen and (-ms-high-contrast:active) {
  .top-nav > ol, .top-nav > ol.menu {
    background: none
  }
}

@media not print {
  .top-nav > ol li, .top-nav > ol.menu li {
    list-style: none
  }

  .top-nav > ol a, .top-nav > ol.menu a {
    border-bottom: 1px solid hsla(0,0%,87%,.35);
    display: block;
    font-weight: 500;
    padding: .5rem .25rem;
    text-decoration: none
  }

  .top-nav > ol > li > ol, .top-nav > ol.menu > li > ol {
    margin: 0
  }

  .top-nav[stuck] {
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    margin-left: -20px;
    margin-right: -20px
  }

    .top-nav[stuck] button {
      border-radius: 0
    }

  .top-nav.open button:before {
    transform: rotate(180deg)
  }

  .top-nav.open > ol, .top-nav.open > ol.menu {
    display: block
  }

    .top-nav.open > ol li:hover {
      background-color: #e5e9ef;
      color: #22272b;
    }

  .top-nav > ol > li > a {
    color: #22272b;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/uilib/navigation/top-nav/top-nav.component.css"],"names":[],"mappings":";AACA;EACE;IACE,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,MAAM;IAEN,+BAA+B;IAC/B;EACF;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IAGE,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,qBAAqB;IACrB,sJAAsJ;IACtJ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,SAAS;IAET,qBAAqB;IAErB,kDAAkD;IAClD,sBAAsB;IACtB;EACF;;IAEE;MACE,mBAAmB;MACnB;IACF;;IAEA;MAEE,gBAAgB;MAChB;IACF;;IAEA;MACE,mBAAmB;MACnB,iBAAiB;MACjB,0BAA0B;MAC1B;IACF;;IAEA;MACE,mBAAmB;MACnB;IACF;;IAEA;MACE;IACF;;IAEA;MACE;IACF;;IAEA;MACE,mBAAmB;MACnB;IACF;;IAEA;MACE,WAAW;MACX,mCAAmC;MACnC,kCAAkC;MAClC,qBAAqB;MACrB,gBAAgB;MAChB,4CAA4C;MAC5C,cAAc;MACd,kBAAkB;MAClB,oBAAoB;MACpB,gBAAgB;MAChB,cAAc;MACd,mBAAmB;MACnB,kBAAkB;MAClB,oBAAoB;MACpB,QAAQ;MACR;IACF;;EAEF;IACE,iCAAiC;IACjC,yBAAyB;IAEzB,oCAAoC;IACpC,cAAc;IACd,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,gBAAgB;IAChB,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB;EACF;;EAEA;IAEE,0PAA0P;IAC1P,gDAAgD;IAChD,sBAAsB;IACtB,4BAA4B;IAC5B;EACF;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;IACE;EACF;;EAEA;IACE,2CAA2C;IAC3C,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB;EACF;;EAEA;IACE;EACF;;EAEA;IAEE,oCAAoC;IACpC,kBAAkB;IAClB;EACF;;IAEE;MACE;IACF;;EAEF;IAEE;EACF;;EAEA;IACE;EACF;;IAEE;MACE,yBAAyB;MACzB,cAAc;IAChB;;EAEF;IACE,cAAc;EAChB;AACF","sourcesContent":["\r\n@media not print {\r\n  .top-nav {\r\n    margin: 1rem 0;\r\n    position: sticky;\r\n    text-align: center;\r\n    top: 0;\r\n    -webkit-transition: margin .1s ease-out;\r\n    transition: margin .1s ease-out;\r\n    z-index: 1000\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 992px) {\r\n  .top-nav {\r\n    display: none\r\n  }\r\n}\r\n\r\n@media not print {\r\n  .top-nav button {\r\n    -webkit-appearance: none;\r\n    -moz-appearance: none;\r\n    appearance: none;\r\n    background: #002664;\r\n    border: 3px solid transparent;\r\n    border-radius: 4px;\r\n    color: #fff;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    font-family: Open Sans,-apple-system,system-ui,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol;\r\n    font-size: 16px;\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n    font-weight: 500;\r\n    line-height: 1.5;\r\n    line-height: 1;\r\n    margin-bottom: -1px;\r\n    padding: .5rem 1rem;\r\n    position: relative;\r\n    text-decoration: none;\r\n    text-shadow: none;\r\n    top: -1px;\r\n    -webkit-transition: .15s ease;\r\n    transition: .15s ease;\r\n    -webkit-transition-property: color,background-color,border;\r\n    transition-property: color,background-color,border;\r\n    vertical-align: middle;\r\n    width: 100%\r\n  }\r\n\r\n    .top-nav button:active {\r\n      border-style: solid;\r\n      border-width: 3px\r\n    }\r\n\r\n    .top-nav button:active, .top-nav button:focus {\r\n      -webkit-box-shadow: none;\r\n      box-shadow: none;\r\n      text-shadow: none\r\n    }\r\n\r\n    .top-nav button:focus {\r\n      border-style: solid;\r\n      border-width: 3px;\r\n      outline: 3px solid #9263de;\r\n      outline-offset: 2px\r\n    }\r\n\r\n    .top-nav button:disabled {\r\n      cursor: not-allowed;\r\n      opacity: .3\r\n    }\r\n\r\n    .top-nav button[href] {\r\n      color: #fff\r\n    }\r\n\r\n    .top-nav button:active, .top-nav button:focus {\r\n      background: #002664\r\n    }\r\n\r\n    .top-nav button:hover:not(:disabled) {\r\n      background: #153d73;\r\n      color: #fff\r\n    }\r\n\r\n    .top-nav button:before {\r\n      speak: none;\r\n      -webkit-font-smoothing: antialiased;\r\n      -moz-osx-font-smoothing: grayscale;\r\n      display: inline-block;\r\n      content: \"\\e901\";\r\n      font-family: \"health-stats-icons\" !important;\r\n      font-size: 1em;\r\n      font-style: normal;\r\n      font-variant: normal;\r\n      font-weight: 400;\r\n      line-height: 1;\r\n      margin-right: .5rem;\r\n      position: relative;\r\n      text-transform: none;\r\n      top: 2px;\r\n      top: 0\r\n    }\r\n\r\n  .top-nav > ol, .top-nav > ol.menu {\r\n    -webkit-overflow-scrolling: touch;\r\n    border-collapse: collapse;\r\n    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.3);\r\n    box-shadow: 0 1px 3px rgba(0,0,0,.3);\r\n    display: block;\r\n    display: none;\r\n    list-style-type: none;\r\n    margin: 0;\r\n    max-height: 98vh;\r\n    max-height: calc(100vh - 38px - 1rem);\r\n    overflow-x: visible;\r\n    overflow-y: auto;\r\n    padding: 10px\r\n  }\r\n\r\n  .top-nav > ol, .top-nav > ol.menu {\r\n    background: -webkit-gradient(linear,left top,left bottom,color-stop(33%,#fff),to(hsla(0,0%,100%,0))),-webkit-gradient(linear,left top,left bottom,from(hsla(0,0%,100%,0)),color-stop(66%,#fff)) 0 100%,radial-gradient(farthest-side at 50% 0,rgba(0,0,0,.2),transparent),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,.2),transparent) 0 100%;\r\n    background: linear-gradient(#fff 33%,hsla(0,0%,100%,0)),linear-gradient(hsla(0,0%,100%,0),#fff 66%) 0 100%,radial-gradient(farthest-side at 50% 0,rgba(0,0,0,.2),transparent),radial-gradient(farthest-side at 50% 100%,rgba(0,0,0,.2),transparent) 0 100%;\r\n    background-attachment: local,local,scroll,scroll;\r\n    background-color: #fff;\r\n    background-repeat: no-repeat;\r\n    background-size: 100% 45px,100% 45px,100% 15px,100% 15px\r\n  }\r\n}\r\n\r\n@media screen and (-ms-high-contrast:active) {\r\n  .top-nav > ol, .top-nav > ol.menu {\r\n    background: none\r\n  }\r\n}\r\n\r\n@media not print {\r\n  .top-nav > ol li, .top-nav > ol.menu li {\r\n    list-style: none\r\n  }\r\n\r\n  .top-nav > ol a, .top-nav > ol.menu a {\r\n    border-bottom: 1px solid hsla(0,0%,87%,.35);\r\n    display: block;\r\n    font-weight: 500;\r\n    padding: .5rem .25rem;\r\n    text-decoration: none\r\n  }\r\n\r\n  .top-nav > ol > li > ol, .top-nav > ol.menu > li > ol {\r\n    margin: 0\r\n  }\r\n\r\n  .top-nav[stuck] {\r\n    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.3);\r\n    box-shadow: 0 1px 3px rgba(0,0,0,.3);\r\n    margin-left: -20px;\r\n    margin-right: -20px\r\n  }\r\n\r\n    .top-nav[stuck] button {\r\n      border-radius: 0\r\n    }\r\n\r\n  .top-nav.open button:before {\r\n    -webkit-transform: rotate(180deg);\r\n    transform: rotate(180deg)\r\n  }\r\n\r\n  .top-nav.open > ol, .top-nav.open > ol.menu {\r\n    display: block\r\n  }\r\n\r\n    .top-nav.open > ol li:hover {\r\n      background-color: #e5e9ef;\r\n      color: #22272b;\r\n    }\r\n\r\n  .top-nav > ol > li > a {\r\n    color: #22272b;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
